"use client"

// Компонент для SVG иконок
export const Icons = {
  // Роли пользователей
  Admin: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>
  ),

  Teacher: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
      />
    </svg>
  ),

  Student: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
      />
    </svg>
  ),

  Logo: ({ className = 'w-6 h6', ...props }) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      version="1.1"
      style={{ fill: "#ffffff", fillOpacity: 1, stroke: "#2563eb", strokeWidth: 1, strokeLinejoin: "round", strokeOpacity: 1 }}
      {...props}>
      <path d="M 1.4204024,4.472013 C 3.968731,4.926477 7.5738822,4.684479 12.008258,8.049579 16.975517,4.31053 19.835105,5.263521 22.579597,4.46926 l -0.01884,15.663373 c -4.726447,0.52614 -8.53036,0.603233 -10.418304,2.069134 C 8.1914333,19.493075 4.3131248,20.672261 1.4941658,20.22899 Z" />
      <path d="m 3.0549393,2.038791 c 3.3513739,0.340822 6.7781745,0.008 8.8832117,3.274273 2.136437,-2.847663 5.416642,-3.54233 9.060689,-3.478686 v 16.474371 c -4.7675,-0.06458 -7.014527,1.762186 -8.856422,3.893018 -2.3242133,-3.34857 -5.7020681,-3.68262 -9.1247425,-3.888429 z" />
      <ellipse cx="12.016117" cy="11.986469" rx="5.6497016" ry="6.5140162" />
      <path d="m 12.119875,5.643689 c 4.3594,3.075902 3.711433,10.577479 0,12.442163 -5.0598025,-3.413384 -3.5115319,-9.319041 0,-12.442163 z" />
      <path d="m 12.016112,5.472458 v 13.028026 0" />
      <path d="M 6.3664088,11.986467 H 17.665815 v 0" />
      <path d="m 7.1332637,8.709699 c 3.2993473,1.255327 6.5597593,1.205271 9.7869993,0.04251 v 0" />
      <path d="M 7.1312095,14.934908 C 10.684835,14.37936 14.06865,14.129396 16.922317,14.833502 v 0" />
    </svg>

  ),

  // Действия
  Delete: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  ),

  Key: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
      />
    </svg>
  ),

  Settings: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),

  Logout: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>
  ),

  Plus: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
    </svg>
  ),

  ArrowLeft: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
    </svg>
  ),

  ChevronDown: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  ),

  // Тренинги
  Abacus: ({ className = "w-8 h-8", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="2" strokeWidth={2} />
      <line x1="2" y1="6" x2="22" y2="6" strokeWidth={2} />
      <line x1="2" y1="10" x2="22" y2="10" strokeWidth={2} />
      <line x1="2" y1="14" x2="22" y2="14" strokeWidth={2} />
      <line x1="2" y1="18" x2="22" y2="18" strokeWidth={2} />
      <circle cx="6" cy="6" r="2" fill="currentColor" />
      <circle cx="6" cy="10" r="2" fill="currentColor" />
      <circle cx="6" cy="14" r="2" fill="currentColor" />
      <circle cx="6" cy="18" r="2" fill="currentColor" />
      <circle cx="18" cy="6" r="2" fill="currentColor" />
      <circle cx="18" cy="10" r="2" fill="currentColor" />
      <circle cx="18" cy="14" r="2" fill="currentColor" />
      <circle cx="18" cy="18" r="2" fill="currentColor" />
    </svg>
  ),

  Brain: ({ className = "w-8 h-8", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  ),

  Puzzle: ({ className = "w-8 h-8", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
      />
    </svg>
  ),

  Book: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
      />
    </svg>
  ),

  Calendar: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  ),

  Trophy: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
      />
    </svg>
  ),

  Bell: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  ),

  // Статусы
  CheckCircle: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),

  XCircle: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),

  // Пользователи
  Users: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        d="M 12.339844 4.0546875 C 10.029666 4.0546875 8.1523438 5.9341958 8.1523438 8.2441406 A 4.1876875 4.1876875 0 0 0 9.921875 11.662109 A 7.3924883 7.3924883 0 0 0 4.9453125 18.617188 L 4.9453125 19.359375 A 0.58533035 0.58533035 0 0 0 5.5292969 19.945312 L 19.123047 19.945312 A 0.58533035 0.58533035 0 0 0 19.707031 19.359375 L 19.707031 18.632812 L 19.707031 18.617188 A 7.3330186 7.3330186 0 0 0 17.541016 13.419922 A 7.3543247 7.3543247 0 0 0 14.75 11.667969 A 4.1876875 4.1876875 0 0 0 16.529297 8.2441406 C 16.529297 5.9341958 14.650023 4.0546875 12.339844 4.0546875 z M 12.341797 5.2246094 C 14.006474 5.2246094 15.359375 6.5796967 15.359375 8.2441406 A 3.0221777 3.0221777 0 0 1 12.341797 11.261719 C 10.677353 11.261719 9.3222656 9.9088196 9.3222656 8.2441406 A 3.0221777 3.0221777 0 0 1 12.341797 5.2246094 z M 6.3417969 5.921875 C 5.5736096 5.921875 4.8602327 6.2860777 4.3320312 6.9472656 C 3.8347347 7.5695892 3.5605469 8.3893373 3.5605469 9.2558594 C 3.5605469 10.122382 3.8347347 10.940959 4.3320312 11.564453 A 3.0949927 3.0949927 0 0 0 4.5722656 11.832031 C 4.5308257 11.852401 4.4884696 11.872761 4.4472656 11.894531 C 3.8827292 12.193519 3.3786163 12.618997 2.9492188 13.158203 C 2.0833986 14.241064 1.6074219 15.672513 1.6074219 17.189453 A 0.5853305 0.5853305 0 1 0 2.7773438 17.189453 C 2.7773438 14.653807 4.3716452 12.589844 6.3320312 12.589844 L 6.3359375 12.589844 L 6.3417969 12.589844 A 0.5853305 0.5853305 0 1 0 6.3417969 11.419922 C 5.9367483 11.419922 5.5474214 11.211407 5.2460938 10.833984 C 4.9138611 10.418168 4.7324219 9.858046 4.7324219 9.2558594 C 4.7324219 8.6536728 4.9138611 8.0935533 5.2460938 7.6777344 C 5.5474214 7.3003141 5.9367483 7.0917969 6.3417969 7.0917969 A 0.58533035 0.58533035 0 0 0 6.3417969 5.921875 z M 18.048828 5.921875 A 0.5859375 0.5859375 0 0 0 18.048828 7.09375 C 18.453876 7.09375 18.842968 7.3000791 19.144531 7.6777344 C 19.476764 8.0935532 19.660156 8.6558589 19.660156 9.2578125 C 19.660156 9.8597642 19.476764 10.420118 19.144531 10.835938 C 18.842968 11.213357 18.453877 11.419922 18.048828 11.419922 A 0.5859375 0.5859375 0 0 0 18.048828 12.591797 L 18.058594 12.591797 C 20.018981 12.591797 21.613281 14.653804 21.613281 17.189453 A 0.5859375 0.5859375 0 0 0 22.785156 17.189453 C 22.786356 15.671342 22.30801 14.240362 21.443359 13.158203 C 21.012791 12.619701 20.508635 12.193518 19.945312 11.894531 C 19.904103 11.872761 19.861754 11.852401 19.820312 11.832031 A 3.0949927 3.0949927 0 0 0 20.058594 11.566406 C 20.555655 10.94385 20.830078 10.122382 20.830078 9.2558594 C 20.830078 8.3893374 20.555655 7.5705249 20.058594 6.9472656 C 19.530392 6.2860776 18.818185 5.921875 18.048828 5.921875 z M 12.326172 12.431641 C 15.744732 12.431641 18.530787 15.214252 18.537109 18.632812 L 18.537109 18.773438 L 18.537109 18.775391 L 6.1152344 18.775391 L 6.1152344 18.632812 C 6.1218344 15.214254 8.9076119 12.431641 12.326172 12.431641 z " />
    </svg>
  ),

  User: ({ className = "w-6 h-6", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
  ),

  // Блокировка
  Lock: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
  ),

  Unlock: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
      />
    </svg>
  ),

  // Загрузка
  Spinner: ({ className = "w-4 h-4", ...props }) => (
    <svg className={`${className} animate-spin`} fill="none" viewBox="0 0 24 24" {...props}>
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  ),
  Close: ({ className = "w-4 h-4", ...props }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
}
